var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cookie-law',{attrs:{"theme":"dark-lime","storage-type":"cookies","message":_vm.$t('cookiebanner.message'),"button-text":_vm.$t('cookiebanner.button')}})}
var staticRenderFns = []

export { render, staticRenderFns }